import { useMemo } from 'react';
import { useField } from 'formik';

interface UseValidationByRules {
  fieldName: string;
  rules: Record<string, (value: string) => boolean>;
}

export const useValidationByRules = ({
  rules,
  fieldName,
}: UseValidationByRules): Record<string, boolean> => {
  const [field] = useField(fieldName);

  return useMemo(
    () =>
      Object.fromEntries(
        Object.entries(rules).map(([ruleName, validate]) => [
          ruleName,
          validate(field.value),
        ])
      ),
    [field.value, rules]
  );
};
